'use client'

import { useState } from 'react'
import { ArrowRight, Eye, EyeOff, Loader2 } from 'lucide-react'
import { useRegisterForm } from '@/lib/commerce/hooks'

const inputStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.035)',
  border: '1px solid rgba(255,255,255,0.07)',
  color: 'white',
}

const labelClass = 'block text-[11px] font-semibold uppercase tracking-[0.18em] mb-2'
const labelStyle: React.CSSProperties = { color: 'rgba(255,255,255,0.7)' }

export default function Register({ vendor }: { vendor?: any }) {
  const f = useRegisterForm(vendor)
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="w-full">
      <div className="text-[10px] font-semibold uppercase tracking-[0.22em]" style={{ color: '#a8a8b3' }}>Шинэ хэрэглэгч</div>
      <h1
        className="mt-3 font-semibold tracking-[-0.025em] leading-[0.95] text-white"
        style={{ fontFamily: 'Gilroy, Inter, sans-serif', fontSize: 'clamp(30px, 4vw, 38px)' }}
      >
        Бүртгэл үүсгэх.
      </h1>

      <form onSubmit={f.handleRegister} className="mt-8 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className={labelClass} style={labelStyle}>Овог</label>
            <input
              autoFocus
              placeholder="Таны овог"
              onChange={(e) => f.setLastName(e.target.value)}
              className="w-full h-12 rounded-full px-5 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
              style={inputStyle}
            />
          </div>
          <div>
            <label className={labelClass} style={labelStyle}>Нэр</label>
            <input
              placeholder="Таны нэр"
              onChange={(e) => f.setFirstName(e.target.value)}
              className="w-full h-12 rounded-full px-5 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
              style={inputStyle}
            />
          </div>
        </div>
        <div>
          <label className={labelClass} style={labelStyle}>Имэйл</label>
          <input
            type="email"
            placeholder="mail@shop.mn"
            onChange={(e) => f.setEmail(e.target.value)}
            className="w-full h-12 rounded-full px-5 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
            style={inputStyle}
          />
        </div>
        <div>
          <label className={labelClass} style={labelStyle}>Утасны дугаар</label>
          <input
            type="tel"
            placeholder="00000000"
            onChange={(e) => f.setPhone(e.target.value)}
            className="w-full h-12 rounded-full px-5 text-[13.5px] tabular-nums outline-none focus:ring-0 placeholder:text-white/30"
            style={inputStyle}
          />
        </div>
        <div>
          <label className={labelClass} style={labelStyle}>Шинэ нууц үг</label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Хамгийн багадаа 8 тэмдэгт"
              onChange={(e) => f.setPassword(e.target.value)}
              onKeyDown={f.handleKeyDown}
              className="w-full h-12 rounded-full pl-5 pr-12 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
              style={inputStyle}
            />
            <button
              type="button"
              onClick={() => setShowPassword(s => !s)}
              aria-label={showPassword ? 'Нууц үг нуух' : 'Нууц үг харах'}
              className="absolute right-4 top-1/2 -translate-y-1/2 transition-colors hover:text-white"
              style={{ color: 'rgba(255,255,255,0.5)' }}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
          <div className="mt-2 text-[11px]" style={{ color: 'rgba(255,255,255,0.5)' }}>
            8-аас дээш тэмдэгтэй байх ёстой
          </div>
        </div>

        <button
          type="submit"
          disabled={f.loading}
          className="w-full h-12 rounded-full text-[14px] font-medium inline-flex items-center justify-center gap-2 transition-opacity disabled:opacity-60"
          style={{ background: 'white', color: '#0a0a0c' }}
        >
          {f.loading ? (
            <><Loader2 className="h-4 w-4 animate-spin" /> Бүртгүүлж байна...</>
          ) : (
            <>Бүртгүүлэх <ArrowRight className="h-3.5 w-3.5" /></>
          )}
        </button>
      </form>

      <p className="mt-7 text-center text-[13px]" style={{ color: 'rgba(255,255,255,0.6)' }}>
        Аль хэдийн бүртгэлтэй юу?{' '}
        <button onClick={f.routeToLogin} className="text-white font-medium underline underline-offset-2 hover:opacity-80 transition-opacity cursor-pointer">
          Нэвтрэх
        </button>
      </p>
    </div>
  )
}
